import { render, staticRenderFns } from "./TempConfigFormGroup.vue?vue&type=template&id=47bcca38&scoped=true"
import script from "./TempConfigFormGroup.vue?vue&type=script&lang=js"
export * from "./TempConfigFormGroup.vue?vue&type=script&lang=js"
import style0 from "./TempConfigFormGroup.vue?vue&type=style&index=0&id=47bcca38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bcca38",
  null
  
)

export default component.exports